<p-dialog [(visible)]="displayEmailDetailPopup" [modal]="true" [style]="{width: '75vw', height:'85vh'}" class="layer2" [blockScroll]="true" [closable]="false" appendTo="body">
    <ng-template pTemplate="header">
        <div class="p-d-flex p-jc-between w-100">
            <h5 class="p-mb-0" *ngIf="emailAudit">{{ emailSubject }}</h5>
            <div class="sentiment p-d-flex">
                <span *ngIf="emailAudit?.objectEmailAuditSentiment?.sentimentText?.toLowerCase() == 'positive'" class="fa fa-smile-o p-mx-2" style="color: green;font-size: 18px;" pTooltip="{{objectEmailAuditSentimentToolTip}}" tooltipPosition="top"></span>
                <span *ngIf="emailAudit?.objectEmailAuditSentiment?.sentimentText?.toLowerCase() == 'negative'" class="fa fa-frown-o p-mx-2" style="color: red;font-size: 18px;" pTooltip="{{objectEmailAuditSentimentToolTip}}" tooltipPosition="top"></span>
                <span *ngIf="emailAudit?.objectEmailAuditSentiment?.sentimentText?.toLowerCase() == 'neutral'" class="fa fa-meh-o p-mx-2" style="color: #e8dc2c;font-size: 18px;" pTooltip="{{objectEmailAuditSentimentToolTip}}" tooltipPosition="top"></span>

                <span class="p-ml-2 btnBars" (click)="refreshEmail(emailAuditId)">
                    <i class="pi pi-refresh" tooltipPosition="top" pTooltip="Sync"></i>
                </span>
            </div>
        </div>
        <button pButton pRipple type="button" icon="pi pi-times" (click)="cancelEmail()" class="p-button-rounded p-dialog-header-icon p-dialog-header-close"></button>
    </ng-template>
    <ng-container *ngIf="!showSpinner">
        <ng-container *ngFor="let thread of emailAudit?.emailThreads; let i = index;">
            <div class="card p-mb-0" style="height: auto !important;">
                <div class="p-d-flex p-jc-between">
                    <div style="flex-grow: 1;" class="email-header">
                        <p class="p-mb-1">
                            <ng-container *ngFor="let recip of thread?.emailRecipients">
                                <ng-container *ngIf="recip.typeId === from.id">
                                    <strong>
                                        <span pTooltip="{{recip.emailAddress}}" tooltipPosition="top" class="pointer">
                                          From: {{recip.name !== '' ? recip.name : recip.emailAddress}}
                                        </span>
                                    </strong>
                                </ng-container>
                            </ng-container>
                            <strong>
                            <span style="opacity: 0.8;" class="p-ml-4">{{thread.receivedDateTime | localDate}}</span>
                        </strong>
                        </p>
                        <p class="p-mb-1" *ngIf="thread?.emailRecipients">To:
                            <ng-container *ngFor="let recip of thread?.emailRecipients;let i = index;">
                                <ng-container *ngIf="recip.typeId === to.id">
                                    <span pTooltip="{{recip.emailAddress}}" tooltipPosition="top" class="pointer">
                                        {{recip?.emailAddress || recip?.name}}
                                    </span>
                                </ng-container>
                            </ng-container>
                        </p>
                        <p *ngIf="thread.hasCC" class="p-mb-1">Cc:
                            <ng-container *ngFor="let recip of thread?.emailRecipients;let i = index;">
                                <ng-container *ngIf="recip.typeId === cc.id">
                                    <span pTooltip="{{recip.emailAddress}}" tooltipPosition="top" class="pointer">
                                        {{recip?.emailAddress || recip?.name}}
                                    </span>
                                </ng-container>
                            </ng-container>
                        </p>
                        <p *ngIf="thread.hasBcc" class="p-mb-1">Bcc:
                            <ng-container *ngFor="let recip of thread?.emailRecipients;let i = index;">
                                <ng-container *ngIf="recip.typeId === bcc.id">
                                    <span pTooltip="{{recip.emailAddress}}" tooltipPosition="top" class="pointer">
                                        {{recip?.emailAddress || recip?.name}}
                                    </span>
                                </ng-container>
                            </ng-container>
                        </p>
                    </div>
                    <div class="p-ml-2" *ngIf="!isViewMode">
                        <span class="btnBars p-mr-0" (click)="startAction('reply', 'S', thread, i)" pTooltip="Reply" tooltipPosition="top">
                            <i class="fa fa-reply"></i>
                        </span>
                        <span class="btnBars p-mr-0" (click)="startAction('replyAll', 'A', thread, i)" pTooltip="Reply all" tooltipPosition="top">
                            <i class="fa fa-reply-all"></i>
                        </span>
                        <span class="btnBars p-mr-0" (click)="startAction('forward', 'F', thread, i)" pTooltip="Forward" tooltipPosition="top">
                            <i class="pi pi-arrow-right"></i>
                        </span>
                    </div>
                </div>
                <div class="p-my-2" *ngIf="thread?.emailAttachments?.length > 0">
                    <ng-container *ngFor="let attach of thread?.emailAttachments">
                        <p-splitButton [label]="checkLabel(attach?.attachment?.name)" [model]="attachOption"
                            styleClass="p-button-outlined p-button-secondary p-mr-2 p-mb-2"
                            (onDropdownClick)="buildOptionsEvent(attach)"
                            [icon]="checkIcons(attach?.attachment?.extension)">
                        </p-splitButton>
                    </ng-container>
                </div>
                <div class="card" style="background: #fff;">
                    <p class="message-body" [innerHTML]="sanitizer.bypassSecurityTrustHtml(thread?.messageData)"></p>
                </div>
            </div>
            <p-divider class="receive-divider" *ngIf="emailAudit?.emailThreads.length > 0"></p-divider>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="showSpinner">
        <p-progressSpinner styleClass="activity-custom-spinner" animationDuration=".5s"></p-progressSpinner>
    </ng-container>
    <app-lion-shared-emails [objectTypeId]="objectTypeId" (syncSendEmail)="syncSendEmailNow($event)" [displaySendEmail]="displaySendEmail" [flag]="flag" [emailAudit]="emailAudit" [thread]="emailThread" (cancelEmailSend)="cancelEmailSend()" (successEmailSend)="successEmailSend()">
    </app-lion-shared-emails>
    <!-- <div class="card p-mb-0">
        <div class="p-d-flex p-jc-between">
            <div style="flex-grow: 1;" class="email-header">
                <p class="p-mb-1">
                    <strong>
                        <span pTooltip="{{emailTemp.fromEmail[0]?.email}}" tooltipPosition="top" class="pointer">
                            {{emailTemp.fromEmail[0]?.user}}
                        </span>
                    </strong>
                    <span style="opacity: 0.8;" class="p-ml-4">{{emailTemp.date | localDate}}</span>
                </p>
                <p class="p-mb-1">To:
                    <ng-container *ngFor="let t of emailTemp.toEmail;let i = index;">
                        <span pTooltip="{{t.email}}" tooltipPosition="top" class="pointer">
                            {{t.user}} <span
                                *ngIf="emailTemp.toEmail.length > 1 && i !== emailTemp.toEmail.length-1">;</span>
                        </span>
                    </ng-container>
                </p>
                <p *ngIf="emailTemp.ccEmail.length > 0" class="p-mb-1">Cc:
                    <ng-container *ngFor="let t of emailTemp.ccEmail;let i = index;">
                        <span pTooltip="{{t.email}}" tooltipPosition="top" class="pointer">
                            {{t.user}} <span
                                *ngIf="emailTemp.ccEmail.length > 1 && i !== emailTemp.ccEmail.length-1">;</span>
                        </span>
                    </ng-container>
                </p>
            </div>
            <div class="p-ml-2">
                <span class="btnBars p-mr-0">
                    <i class="fa fa-reply"></i>
                </span>
                <span class="btnBars p-mr-0">
                    <i class="fa fa-reply-all"></i>
                </span>
                <span class="btnBars p-mr-0">
                    <i class="pi pi-arrow-right"></i>
                </span>
            </div>
        </div>
    </div>
    <div class="card" style="background: #fff;">
        <p>Hello World,</p>
        <p>{{emailTemp.message}}</p>
        <p class="p-mb-1">Thanks,</p>
        <p>{{emailTemp.fromEmail[0]?.user}}</p>
    </div>
    <p-divider class="receive-divider"
        *ngIf="emailTemp.fromEmail[0]?.user !== app.user.userName && emailTemp.thread.length > 0"></p-divider>
    <p-divider class="send-divider"
        *ngIf="emailTemp.fromEmail[0]?.user == app.user.userName && emailTemp.thread.length > 0"></p-divider> -->
</p-dialog>
